import { Pipe, PipeTransform } from '@angular/core';
import { Campaign } from '../models/campaign.model';

@Pipe({
  name: 'campaignYear',
  standalone: true,
})
export class CampaignYearPipe implements PipeTransform {
  transform(item: Campaign, attr: any): any {
    const yearStart = (<Date>item.startingOn).getUTCFullYear();
    const yearEnd = (<Date>item.endingOn).getUTCFullYear();
    if (yearStart === yearEnd) {
      return yearStart;
    }
    return yearStart + ' - ' + yearEnd;
  }
}
